const fields = (state = [], action) => {
    switch (action.type) {
        case 'RESET_FIELDS':

            return {data: action.fields, version: (new Date()).getTime()}
        case 'INSERT_FIELD':


            return {
                data: {...state.data, ...action.field},
                // version: (new Date()).getTime()
            }

        case 'INSERT_SECTION':

            return {
                data: {...state.data, ...action.field},
                // version: (new Date()).getTime()
            }
        case 'UPDATE_SECTION':

            return {
                data: action.field,
                // version: (new Date()).getTime()
            }
        case 'TOGGLE_TODO':
            return state.map(todo =>
                todo.id === action.id ? {...todo, completed: !todo.completed} : todo
            )
        default:
            return state
    }
}

export default fields
